import React from 'react';
import PropTypes from 'prop-types';
import style from './comp.App.module.css';
import Logo from './logo.png';
import { Link } from 'react-router';
import { track, EVENT_TYPE_PRODUCT } from 'app/utils/eventTrack';

export default function App(props) {
  return (<div className={style.container}>
    <div className={style.header}>
      <div className={style.logo}>
        <Link
          onClick={() => track('home-click', EVENT_TYPE_PRODUCT)}
          to="/">
          <img alt="logo" src={Logo} />ENGLISH NUMBERS
        </Link>
      </div>
      <nav className={style.lang} aria-label="Language">
        <span className={style.langActive}>EN</span>
        <span className={style.langSep}>|</span>
        <a href="/zh/index.html">中文</a>
      </nav>
    </div>
    {props.children}
  </div>);
}

App.propTypes = {
  children: PropTypes.any,
};



// WEBPACK FOOTER //
// ./src/routes/app/comp.App.js